import React from 'react';
import { Link } from "react-router-dom";
import { Trans } from 'react-i18next';

import { CompanyContext } from '../CompanyContext';

export function Cancel() {
    const { company, t } = React.useContext(CompanyContext);

    return (
        company &&
        <div className="container text-center">
            <h1>{t('Order Cancelled')}</h1>
            <hr />
            <p className="lead text-danger payment-declined-text">
                <Trans t={t}>You have cancelled your transaction, please <Link to="/">click here to go back</Link>.</Trans>
            </p>
            <p><Trans t={t}>Please refer to <Link to={'/' + company.Key + '/faqs'}>our FAQ</Link> for more information</Trans></p>
            <p><Trans t={t}>If you would like to try again, please <Link to="/">click here to return to the beginning of the form</Link></Trans></p>
        </div>
    );
}
